module.exports = __webpack_public_path__ + "static/img/duban.9a5f5bac.png";